export default defineNuxtRouteMiddleware(async (to) => {
  const { status } = useAuthState();
  const pageAuth = to.meta.auth;

  if (pageAuth === false) return;

  // Wait for the auth state to resolve before making redirect decisions.
  // The sidebase built-in middleware has no guard for status === 'loading', which
  // causes false redirects to /login during token refresh — sidebase calls
  // getSession() internally inside refresh(), briefly setting loading = true.
  // Any navigation during that ~100-400ms window ends up redirected to /login.
  if (status.value === 'loading') {
    await new Promise<void>((resolve) => {
      const stop = watch(status, (s) => {
        if (s !== 'loading') {
          stop();
          resolve();
        }
      });
    });
  }

  const isAuthenticated = status.value === 'authenticated';

  const isGuestOnly =
    typeof pageAuth === 'object' &&
    pageAuth !== null &&
    'unauthenticatedOnly' in pageAuth &&
    (pageAuth as { unauthenticatedOnly?: boolean }).unauthenticatedOnly ===
      true;

  if (isGuestOnly) {
    if (isAuthenticated) {
      const destination = (pageAuth as { navigateAuthenticatedTo?: string })
        .navigateAuthenticatedTo;
      return navigateTo(destination ?? '/');
    }
    return;
  }

  if (!isAuthenticated && !to.path.startsWith('/auth/login')) {
    return navigateTo(
      `/auth/login?redirect=${encodeURIComponent(to.fullPath)}`,
    );
  }
});
